<template>
  <div v-show="visible" class="menu-controls">
    <div v-if="showPayGo" class="flex">
      <Button
        block
        data-cy="pay-go-button-cta"
        :dark="!isPlaceOrderButtonWhite"
        :white="isPlaceOrderButtonWhite"
        :background-color="
          this.$store.getters.customizationMenuPlaceOrderButtonBackgroundColor
        "
        @click="navigateToPayGo"
      >
        <span
          :style="{
            color: this.$store.getters
              .customizationMenuPlaceOrderButtonTextColor,
          }"
          >{{ $t('screens.menu.payBillCta') }}</span
        >
      </Button>
    </div>
    <v-row
      v-if="$store.getters.functionalityOrderEnabled"
      no-gutters
      style="flex-wrap: nowrap; gap: 8px"
    >
      <!-- Button for going to order list -->
      <v-col
        v-if="isViewOrderButtonActive"
        class="flex-grow-0 flex-shrink-0 mr-2"
      >
        <Button @click="navigateToOrders">
          {{ getGoToOrdersButtonText }}
          <img
            :src="require(`@/assets/images/icons/food-icon.svg`)"
            class="ml-2"
            width="20"
            height="20"
          />
        </Button>
      </v-col>

      <!-- Button for placing order -->
      <v-col v-if="isPlaceOrderButtonActive" class="flex-grow-1 flex-shrink-0">
        <Button
          :dark="!isPlaceOrderButtonWhite"
          :white="isPlaceOrderButtonWhite"
          :background-color="
            this.$store.getters.customizationMenuPlaceOrderButtonBackgroundColor
          "
          :text-color="
            this.$store.getters.customizationMenuPlaceOrderButtonTextColor
          "
          data-cy="place-order-button"
          @click="navigateToPlaceOrder"
        >
          <span
            :class="{
              'place-order-button-content--dark-text': isPlaceOrderButtonWhite,
            }"
            :style="{
              color:
                this.$store.getters.customizationMenuPlaceOrderButtonTextColor +
                '!important',
            }"
          >
            {{ $t('screens.menu.viewOrderCtaLabel') }}
          </span>
          <v-spacer></v-spacer>
          <div
            class="white rounded-circle black--text d-flex align-center justify-center"
            style="width: 20px; height: 20px;"
          >
            {{ cartCount }}
          </div>
        </Button>
      </v-col>
      <Button
        v-else-if="
          $store.getters.ordersTemporarilyDisabled &&
            $store.getters.functionalityOrderEnabled &&
            !$store.getters.functionalityPayGoEnabled
        "
        dark
        disabled
        center
      >
        {{ getOrdersTemporaryDisabledButtonText }}
      </Button>
    </v-row>
  </div>
</template>

<script>
import Button from '@/components/Button.vue';
export default {
  components: {
    Button,
  },
  computed: {
    session() {
      return this.$store.state.session;
    },
    isSingleControl() {
      return !this.isViewOrderButtonActive || !this.isPlaceOrderButtonActive;
    },
    isOnlySingleActiveOrder() {
      return (
        this.$store.getters.ordersCount === 1 &&
        this.$store.getters.activeOrdersCount === 1
      );
    },
    isViewOrderButtonActive() {
      return this.$store.getters.ordersCount > 0;
    },
    isPlaceOrderButtonActive() {
      return (
        this.$store.getters.cartCount >= 0 &&
        !this.$store.getters.ordersTemporarilyDisabled
      );
    },
    isOrdersDisabledButtonActive() {
      return this.$store.getters.ordersTemporarilyDisabled;
    },
    getGoToOrdersButtonText() {
      if (this.restaurantFoodCourtHash && !this.isKiosk) {
        return this.$t('foodCourt.restaurantList.cta');
      }

      return this.$t('screens.menu.viewOrdersCta');
    },
    getOrdersTemporaryDisabledButtonText() {
      if (this.isViewOrderButtonActive) {
        return this.$t('screens.menu.ordersDisabledShortCtaLabel');
      } else {
        return this.$t('screens.menu.ordersDisabledCtaLabel');
      }
    },
    showPayGo() {
      return (
        this.$store.getters.functionalityPayGoEnabled &&
        !this.$store.getters.functionalityOrderEnabled
      );
    },
    isPlaceOrderButtonWhite() {
      return this.$store.getters.customizationMenuPlaceOrderButtonWhite;
    },
    orderEnabled() {
      return this.$store.getters.functionalityOrderEnabled;
    },
    visible() {
      return this.showPayGo || this.orderEnabled;
    },
    foodCourtHash() {
      return this.$store.getters.getFoodCourtHash;
    },
    restaurantFoodCourtHash() {
      return this.$store.getters.restaurantFoodCourtHash;
    },
    isKiosk() {
      return this.$store.getters.tableTypeIsSelfService;
    },
    cartCount() {
      if (this.restaurantFoodCourtHash && !this.isKiosk) {
        return this.$store.getters.getTotalCartItemsCount;
      }

      return this.$store.getters.cartCount;
    },
  },
  methods: {
    navigateToPlaceOrder() {
      if (this.restaurantFoodCourtHash && !this.isKiosk) {
        this.$router.push({
          name: 'FoodCourtCart',
          params: { foodCourtHash: this.foodCourtHash },
        });
        return;
      }
      this.$router.push({
        name: 'PlaceOrder',
        params: { session: this.session },
      });

      this.$store.dispatch('sendAnalyticsEvent', {
        event: 'navigate_to_view_order',
      });
    },
    navigateToOrders() {
      if (this.restaurantFoodCourtHash && !this.isKiosk) {
        this.$router.push({
          name: 'FoodCourtOrders',
          params: { foodCourtHash: this.foodCourtHash },
        });
        return;
      }

      if (
        this.$store.getters.ordersCount === 1 &&
        this.$store.getters.activeOrdersCount === 1
      ) {
        const orderNumber = this.$store.state.orders[0].unique_order_number;
        this.$store.dispatch('openOrder', orderNumber);
      } else {
        this.$router.push({
          name: 'Orders',
          params: { session: this.session },
        });
      }

      this.$store.dispatch('sendAnalyticsEvent', {
        event: 'navigate_to_view_orders',
      });
    },
    navigateToPayGo() {
      const orderNumber = this.$store.getters.getFirstPOSOpenOrderId;
      let params = {
        name: 'Order',
        params: { session: this.session },
      };
      if (orderNumber) {
        params.query = { orderNumber };
      }
      this.$router.push(params);
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-controls {
  position: fixed;
  bottom: 0px;
  width: 100%;
  display: flex;
  gap: 1em;
  justify-content: space-between;
  padding: 2em 1em calc(2em + env(safe-area-inset-bottom)) 1em;
  background-image: linear-gradient(
    to top,
    var(--menu-background-color, white) 0%,
    var(--menu-background-color, white) 30%,
    rgba(0, 212, 255, 0) 100%
  );

  @media screen and (min-width: $max-app-width) {
    max-width: $max-app-width;
  }
}
</style>
